import React, { useState } from 'react'
import { render } from "storyblok-rich-text-react-renderer"
import { sbEditable } from "@storyblok/storyblok-editable";

const linkStyle = { color: "#c98a00", textDecoration: "underline" }
const linkHoverStyle = { color: "#a36e00", textDecoration: "underline" }

const btnStyle = {
    display: "inline-block",
    backgroundColor: "#ffb70f",
    color: "#333",
    textDecoration: "underline",
    padding: "0.35em 0.9em",
    borderRadius: "4px",
    fontWeight: "600",
    marginRight: "0.75rem",
}
const btnHoverStyle = { ...btnStyle, backgroundColor: "#e6a50e" }

const StyledLink = ({ href, download, button, children }) => {
    const [hovered, setHovered] = useState(false)
    const style = button
        ? (hovered ? btnHoverStyle : btnStyle)
        : (hovered ? linkHoverStyle : linkStyle)
    return (
        <a
            href={href}
            download={download}
            target="_blank"
            rel="noopener noreferrer"
            style={style}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        >
            {children}
        </a>
    )
}

const ResourcesList = ({ blok }) => {
    console.log(blok)

    const EventList = blok.resource.map((resource, i) => {
        const hasLink = resource.link?.url
        const hasFile = resource.file?.filename

        return <div className="card mb-5" key={i} style={{ backgroundColor: "transparent", border: "2px solid #fbd875" }}>
            <div className="card-content">
                <div className="column is-11">
                    <div className="content">
                        <p className="has-text-weight-bold is-size-5">{resource.title}</p>
                        <p>
                            {render(resource.description)}
                        </p>
                        {hasFile && (
                            <StyledLink href={resource.file.filename} download button>
                                Download
                            </StyledLink>
                        )}
                        {hasLink && (
                            <StyledLink href={resource.link.url}>
                                Link
                            </StyledLink>
                        )}
                    </div>
                </div>
            </div>
        </div>
    })

    return (
        <div {...sbEditable(blok)}>
            <div className="section" style={{ backgroundColor: "#FFF" }}>
                <div className="container">
                    <h1
                        className="is-size-3 label has-text-centered"
                    >
                        {blok.title}
                    </h1>
                    {EventList}
                </div>

            </div>
        </div>
    )
}

export default ResourcesList;